module.exports = __webpack_public_path__ + "img/Broken Stone.96feb3e4.png";